import React, { useCallback } from "react";
import classNames from "classnames";

import useFilters from "hooks/useFilters";

import { MobileFilterShortcutsType } from "components/FilteredGrid/MobileFilters";
import ChevronIcon from "components/Icons/ChevronIcon";

import usePublishFilterClickEvent from "../hooks/usePublishFilterClickEvent";
import {
  MenuFilterGroupTypes,
  MenuFiltersGroup,
  MenuFiltersToggle,
} from "../types/MenuFilters";

const MobileMenuFilterShortcuts: MobileFilterShortcutsType = ({
  onShortcutClick,
  availableFilters,
  menuPage,
}) => {
  const { toggleFilter } = useFilters();
  const { publishFilterSectionClickEvent } =
    usePublishFilterClickEvent(menuPage);

  const onFilterSectionClick = useCallback(
    ({ name, type }: MenuFiltersGroup | MenuFiltersToggle) => {
      publishFilterSectionClickEvent(name);

      if (type === MenuFilterGroupTypes.toggle) {
        return toggleFilter({ [name]: "true" });
      }

      onShortcutClick(name);
    },
    [onShortcutClick, publishFilterSectionClickEvent, toggleFilter],
  );
  return (
    <>
      {availableFilters.map((filter: MenuFiltersGroup | MenuFiltersToggle) => (
        <MobileMenuFilterShortcut
          key={filter.name}
          text={filter.label as string}
          type={filter.type}
          onClick={() => onFilterSectionClick(filter)}
        />
      ))}
    </>
  );
};

const MobileMenuFilterShortcut: React.FC<{
  onClick: () => void;
  text: string;
  type: MenuFilterGroupTypes;
}> = ({ onClick, text, type }) => {
  const toggleFilter = type === MenuFilterGroupTypes.toggle;
  return (
    <button
      onClick={onClick}
      className={classNames(
        "border border-light-grey flex font-bold items-center leading-none  rounded text-green text-xs min-w-max",
        {
          "p-2": toggleFilter,
          "pl-md pr-sm py-xs": !toggleFilter,
        },
      )}
      data-testid="mobile-filter-shortcut"
    >
      {text}
      {!toggleFilter && (
        <ChevronIcon
          direction="right"
          className="flex-none"
          height="20"
          width="20"
        />
      )}
    </button>
  );
};

export default MobileMenuFilterShortcuts;
